@if (currentFormHeader) {
<h4 class="form-title">{{ currentFormHeader.DESCRIPTION }}</h4>
}

<div id="table_container">
  <table class="table table-bordered custom-table form-inline">
    <tr>
      <th>{{ tableHeader[0]?.LINE_DISP }}</th>
      <th style="text-align: center;">{{ tableHeader[0]?.DESCRIPTION }}</th>
      <th style="text-align: center;">Amount</th>
    </tr>

    @for (row of rows; track trackByLineAttribKey($index, row)) {
<tbody class="table1">
      <tr>
        @if (row.ROW_TYPE !== 'PH') {

          <td>{{ row.LINE_DISP }}</td>
        
}
        @if (row.ROW_TYPE === 'PH') {

          <td class="color-red"><b>{{ row.LINE_DISP }}</b></td>
        
}

        @if (hasDescription(row)) {

          <td>
            <span>{{ row.DESCRIPTION }}</span>
          </td>
        
}

        @if (row.ROW_TYPE === 'PH') {

          <td colspan="2"><span class="color-red"><b>{{ row.DESCRIPTION }}</b></span></td>
        
}

        @if (isRegularRow(row)) {

          @for (row1 of getNonCheckboxCells(row.FORM_LINE_KEY); track trackByLineAttribKey($index, row1)) {
<td
              style="width: 100px;">
            @if (row1.IS_EDITABLE_CELL === 'N' && row1.EDIT_TYPE !== 'checkbox' && row.DATA_TYPE !== 'dateVarious') {
<div
                 style="text-align: right; padding-right: 10px"
                 [class.color-red]="row1.ATTRIB_VALUE < 0">
              <span>{{ row1.ATTRIB_VALUE }}</span>
            </div>
}
            @if (row.DATA_TYPE === 'dateVarious') {
<div
                 style="text-align: right; padding-right: 10px"
                 [class.color-red]="row1.ATTRIB_VALUE < 0">
              <gtw-credits-date-various
                [row]="row1"
                (changed)="onDateVariousChange(row1)">
              </gtw-credits-date-various>
            </div>
}
            @if (row1.IS_EDITABLE_CELL === 'Y' && row1.EDIT_TYPE !== 'checkbox' && row.DATA_TYPE !== 'dateVarious') {
<div
                 style="text-align: right; padding-right: 10px">
              @if (row1.DATA_TYPE === 'number') {
<input
                     class="form-control input-md numText"
                     style="text-align: right" type="text"
                     [ngModel]="row1.ATTRIB_VALUE"
                     (ngModelChange)="onTextChange(row1, $event)">
}
              @if (row1.DATA_TYPE === 'string') {
<input
                     class="form-control input-md numText"
                     style="text-align: right" type="text"
                     [ngModel]="row1.ATTRIB_VALUE"
                     (ngModelChange)="onTextChange(row1, $event)">
}
            </div>
}
          </td>
}
        
}

        @if (row.ROW_TYPE === 'TH4' || row.ROW_TYPE === 'TH6') {

          <td colspan="2">
            @for (row1 of (tableHeader || []); track trackByLineAttribKey($index, row1)) {
<div class="col-md-3 subTable"
                
                 [hidden]="!(row1.ROW_TYPE === row.ROW_TYPE && row1.ROW_TYPE === 'TH4')">
              {{ row1.ATTRIB_DESCRIPTION }}
            </div>
}
            @for (row1 of (formList || []); track trackByLineAttribKey($index, row1)) {
<div class="col-md-2 subTable"
                
                 [hidden]="!(row1.ROW_TYPE === row.ROW_TYPE && row1.ROW_TYPE === 'TH6' && row1.IS_FORM_DISPLAY === 'Y')">
              {{ row1.ATTRIB_DESCRIPTION }}
            </div>
}
          </td>
        
}

        @if (row.ROW_TYPE === 'DT4' || row.ROW_TYPE === 'DT6') {

          <td colspan="2">
            @if (row.ROW_TYPE === 'DT4') {

              @for (row1 of getNonCheckboxCells(row.FORM_LINE_KEY); track trackByLineAttribKey($index, row1)) {
<div class="col-md-3"
                  >
                @if (row1.IS_EDITABLE_CELL === 'N' && row1.EDIT_TYPE !== 'checkbox') {
<div
                     style="text-align: right; padding-right: 10px"
                     [class.color-red]="row1.ATTRIB_VALUE < 0">
                  <span>{{ row1.ATTRIB_VALUE }}</span>
                </div>
}
                @if (row1.IS_EDITABLE_CELL === 'Y' && row1.EDIT_TYPE !== 'checkbox') {
<div
                     style="text-align: right; padding-right: 10px">
                  @if (row1.DATA_TYPE === 'number') {
<input
                         class="form-control input-md numText"
                         style="text-align: right" type="text"
                         [ngModel]="row1.ATTRIB_VALUE"
                         (ngModelChange)="onTextChange(row1, $event)">
}
                  @if (row1.DATA_TYPE === 'string') {
<input
                         class="form-control input-md numText"
                         style="text-align: right" type="text"
                         [ngModel]="row1.ATTRIB_VALUE"
                         (ngModelChange)="onTextChange(row1, $event)">
}
                </div>
}
              </div>
}
            
}
            @if (row.ROW_TYPE === 'DT6') {

              @for (row1 of getNonCheckboxCells(row.FORM_LINE_KEY); track trackByLineAttribKey($index, row1)) {
<div class="col-md-2"
                  >
                @if (row1.IS_EDITABLE_CELL === 'N' && row1.EDIT_TYPE !== 'checkbox') {
<div
                     style="text-align: right; padding-right: 10px"
                     [class.color-red]="row1.ATTRIB_VALUE < 0">
                  <span>{{ row1.ATTRIB_VALUE }}</span>
                </div>
}
                @if (row1.IS_EDITABLE_CELL === 'Y' && row1.EDIT_TYPE !== 'checkbox') {
<div
                     style="text-align: right; padding-right: 10px">
                  @if (row1.DATA_TYPE === 'number') {
<input
                         class="form-control input-md numText"
                         style="text-align: right" type="text"
                         [ngModel]="row1.ATTRIB_VALUE"
                         (ngModelChange)="onTextChange(row1, $event)">
}
                  @if (row1.DATA_TYPE === 'string') {
<input
                         class="form-control input-md numText"
                         style="text-align: right" type="text"
                         [ngModel]="row1.ATTRIB_VALUE"
                         (ngModelChange)="onTextChange(row1, $event)">
}
                </div>
}
              </div>
}
            
}
          </td>
        
}

        @if (isDT20(row)) {

          <td>
            @if (row.EDIT_TYPE === 'checkbox') {
<div class="col-md-4"
                 style="text-align: left; padding-right: 10px;"
                >
              @for (row1 of getCheckboxCells(row.FORM_LINE_KEY); track trackByLineAttribKey($index, row1)) {
<div>
                <label>
                  <input type="checkbox"
                         [checked]="row1.ATTRIB_VALUE === 'true'"
                         (change)="onCheckbox8912(row1, $event)">
                  {{ row1.ATTRIB_DESCRIPTION }}
                </label>
              </div>
}
            </div>
}
            @for (row1 of getNonCheckboxCells(row.FORM_LINE_KEY); track trackByLineAttribKey($index, row1)) {
<div class="col-md-4"
                
                 [class.color-red]="row1.ATTRIB_VALUE < 0">
              <span>{{ row1.ATTRIB_VALUE }}</span>
            </div>
}
          </td>
        
}
      </tr>
    </tbody>
}
  </table>
</div>
